import {
  KioskConfiguration,
  KioskConfigurationCreatePayload,
  KioskConfigurationUpdatePayload,
} from "../models/kiosk-configuration";
import { httpClient, uploadImageAndGetCdnUrl } from "../../../service/http";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import { OrganizationKeyName } from "../../../model/Organization";

export const kioskConfigurationHttp = {
  createKioskConfiguration: async ({
    organizationKeyName,
    data,
  }: PostPayload<KioskConfigurationCreatePayload>): Promise<string> => {
    const res = await httpClient<{ data: { id: string } }>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/shop-self-service-configs`,
      data,
    });
    return res.data.id;
  },

  updateKioskConfiguration: ({
    organizationKeyName,
    data: { id, ...rest },
  }: PutPayload<KioskConfigurationUpdatePayload>) => {
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/shop-self-service-configs/${id}`,
      data: rest,
    });
  },

  deleteKioskConfiguration: async ({
    organizationKeyName,
    data: { id },
  }: DeletePayload) => {
    return httpClient({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/shop-self-service-configs/${id}`,
    });
  },

  getKioskConfigurations: async (organizationKeyName: OrganizationKeyName) => {
    const res = await httpClient<{ data: KioskConfiguration[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-self-service-configs`,
    });
    return res.data;
  },

  getKioskConfiguration: async (
    organizationKeyName: OrganizationKeyName,
    id?: string
  ) => {
    const data = await kioskConfigurationHttp.getKioskConfigurations(
      organizationKeyName
    );
    return data.find((kioskConfiguration) => kioskConfiguration.id === id);
  },

  uploadConfigImage: uploadImageAndGetCdnUrl,
};
